/**
 * Solid matte surfaces and refined tones across the application.
 */
export const SPECIAL_GRADIENT = 'linear-gradient(135deg, #1F1D1A 0%, #141210 100%)'
export const BALANCE_GRADIENT = 'linear-gradient(135deg, #1A1E24 0%, #10141A 100%)'
export const MARKET_GRADIENT = 'linear-gradient(135deg, #0F291E 0%, #091A13 100%)'
export const HERO_GLOW_GRADIENT = 'none'
